var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnMenuSystemStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.48,
    height: 19.967,
    viewBox: "0 0 22.48 19.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.a{stroke:#007c9f;}.b{stroke:#0eb4d0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8.984,
    cy: 8.984,
    r: 8.984,
    transform: "translate(2.513)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1029.44-100.371h7.959l1.676-3.142,3.184,6.451,1.8-3.393h2.43",
    transform: "translate(-1029.44 109.252)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMenuSystemStatus);
export default __webpack_public_path__ + "static/media/icn-menu-system-status.128e3d3a569c9f075ed4603b852331cb.svg";
export { ForwardRef as ReactComponent };